import React, {useEffect, useState} from 'react'
import {Button, Form, Modal, AutoComplete, Input, DatePicker, Select, message} from "antd";
import {getAddressByCustomerId} from "../../../services/serviceAddress";
import {createShippingOrder} from "../../../services/serviceShippingOrder";
import ShippingOrderFirmCodeBulk from "../../shippingOrder/ShippingOrderFirmCodeBulk";

const {Option} = AutoComplete;
const {TextArea} = Input;

const dateFormat = 'DD/MM/YYYY';

const shipmentTypes = {
    "VEHICLE": "ARAÇ",
    "CARGO": "KARGO",
    "MANUEL": "ELDEN"
};
const OfferDetailShippingModal = ({offer, modal, modalCloser}) => {

    const [form] = Form.useForm();
    const [customerAddress, setCustomerAddress] = useState([]);
    const [selectedAddress, setSelectedAddress] = useState();
    const [bulkList, setBulkList] = useState([]);

    useEffect(() => {
        getAddressByCustomerId(offer.bid.customer.id)
            .then(({data}) => {
                let addArr = []
                data.forEach(item => {
                    let addrObj = {
                        key: item.id,
                        text: item.title
                    };
                    addArr.push(addrObj);
                })
                setCustomerAddress(addArr);
            })
    }, [])

    const handleAddressChange = (v, {key}) => setSelectedAddress(key)
    const handleBulkList = (stockId, key, value, index, contentId) => {
        const mockList = bulkList;
        const matchedItem = mockList.find(item => item.contentId === contentId);

        if (matchedItem && key === 'warehouse') {
            matchedItem.warehouse = value;
            setBulkList([...mockList]);
            return;
        }

        if (matchedItem && key === 'quantity') {
            matchedItem.quantity = value;
            setBulkList([...mockList]);
            return;
        }

        if (matchedItem && key === 'customerStockCode') {
            matchedItem.customerStockCode = value;
            setBulkList([...mockList]);
            return;
        }

        const relatedItemAmount = form.getFieldValue(`quantity-${stockId}-${index}`)
        let bulkItem = {
            stock: {
                id: stockId
            },
            [key]: value,
            contentId: contentId
        };

        if (key !== 'quantity' && relatedItemAmount) {
            bulkItem.quantity = relatedItemAmount;
        }
        mockList.push(bulkItem);
        setBulkList([...mockList]);
    }
    const handleSubmit = () => {
        if (!bulkList.length || !bulkList.every(item => item.warehouse && item.warehouse.id && Number(item.quantity))) {
            message.warning('Depo ve Adet Alanları boş olamaz');
            return;
        }

        const {
            shippingDate,
            note,
            shipmentType
        } = form.getFieldsValue()

        let shippingOrderContentList = []
        offer.bid.contentOfBidList.forEach(item => {
            const matchedStock = bulkList.find(bulkItem => bulkItem.contentId === item.id)
            if (matchedStock && matchedStock.warehouse && Object.values(matchedStock).length >= 2) {
                const contentItem = {
                    customerStockCode: matchedStock.customerStockCode,
                    price: item.linePrice ? item.linePrice : item.stock.price,
                    quantity: matchedStock.quantity,
                    stock: {
                        id: matchedStock.stock.id
                    },
                    unitPrice: 0,
                    warehouse: {
                        id: matchedStock.warehouse.id
                    }
                }
                shippingOrderContentList.push(contentItem)
            }
        })
        let requestObj = {
            bid: {id: offer.bid.id},
            customer: {id: offer.bid.customer.id},
            customerAddress: {id: selectedAddress},
            dispatchType: 'SHIPMENT',
            dispatchNo: '',
            note: note,
            shipmentDate: shippingDate._d,
            shipmentStatus: 'WAITING',
            shippingOrderContentList: shippingOrderContentList,
            shippingType: shipmentType
        }
        createShippingOrder(requestObj)
            .then(() => modalCloser())
    }

    return (
        <React.Fragment>
            <Modal
                open={modal}
                style={{minWidth: '75%'}}
                closable={false}
                title={'Sevk İrsaliyesi Oluştur'}
                footer={[
                    <Button
                        key={'SubmitButton'}
                        onClick={() => form.submit()}
                        type={'primary'}
                    >
                        Kaydet
                    </Button>,
                    <Button
                        key={'CancelButton'}
                        onClick={modalCloser}
                    >
                        Kapat
                    </Button>
                ]}
            >
                <Form
                    labelCol={{span: 8}}
                    wrapperCol={{span: 16}}
                    onFinish={handleSubmit}
                    labelAlign={"left"}
                    form={form}
                >
                    {
                        offer.bid.contentOfBidList.map((item, index) => {
                            if (item.bidStatus === 'POSITIVE') {
                                return <ShippingOrderFirmCodeBulk
                                    key={index}
                                    index={index}
                                    contentId={item.id}
                                    formInstance={form}
                                    itemInfo={item}
                                    handler={handleBulkList}
                                    stockId={item.stock.id}
                                    stockLabel={`${item.stock.code} - ${item.stock.name}`}
                                />
                            }
                        })
                    }
                    <Form.Item
                        name={'customerAddress'}
                        label={'Adres'}
                        rules={[
                            {required: true, message: 'Bu Alan Boş Bırakılamaz'},
                            () => ({
                                validator(rule, value) {
                                    let hasValue = customerAddress.filter(addr => addr.text.toLowerCase() === value.toLowerCase())
                                    if (value && hasValue.length > 0) {
                                        handleAddressChange(true, {key: hasValue[0].key})
                                        return Promise.resolve();
                                    }

                                    return Promise.reject('Lütfen Geçerli Bir Değer Giriniz');
                                },
                            }),
                        ]}
                    >
                        <AutoComplete
                            filterOption={(inputValue, option) =>
                                option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                            }
                        >
                            {customerAddress.map(item => {
                                return <Option key={item.key} value={item.text}>{item.text}</Option>
                            })}
                        </AutoComplete>
                    </Form.Item>
                    <Form.Item
                        label={'Sevkiyat Tarihi'}
                        name={'shippingDate'}
                        rules={[
                            {required:true, message: 'Bu Alan Boş Bırakılamaz'}
                        ]}
                    >
                        <DatePicker format={dateFormat} placeholder={'Tarih seçiniz'}/>
                    </Form.Item>
                    <Form.Item
                        label={'Gönderim Şekli'}
                        name={'shipmentType'}
                        rules={[
                            {required: true, message: 'Bu Alan Boş Bırakılamaz'}
                        ]}
                    >
                        <Select>
                            {
                                Object.keys(shipmentTypes).map(key => {
                                    return <Option key={key} value={key}>{shipmentTypes[key]}</Option>
                                })
                            }
                        </Select>
                    </Form.Item>
                    <Form.Item
                        name={'note'}
                        label={'Not'}
                    >
                        <TextArea/>
                    </Form.Item>
                </Form>
            </Modal>
        </React.Fragment>
    )
}
export default OfferDetailShippingModal